import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataContract } from '../../models/data-contract.model';
import { SessionService } from '../../services/session.service';

import { PaymentService } from '../../../shared/services/payment.service';
import swal from 'sweetalert2';
import { MenuUtility } from '../../utilities/menu.utility';

declare var jQuery: any;

@Component({
  selector: 'app-layout-sidebar-menu',
  templateUrl: './layout-sidebar-menu.component.html',
  styleUrls: ['./layout-sidebar-menu.component.css']
})
export class LayoutSidebarMenuComponent implements OnInit {

  isColective: boolean;
  stateContract: string;
  contratante: boolean;
  dataContract: DataContract;
  showNews: boolean;
  showEstadoCuenta: boolean;
  showPagoEnLinea : boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _sessionService: SessionService,
    private _paymentService: PaymentService
  ) { }

  ngOnInit() {

    this.validateContract();
    this.dataContract = this._sessionService.getDataContract();

    this._sessionService.changeContractObservable.asObservable().subscribe(
      value => {
        //console.log("se ejecuta observable sidevar");
        if (value) {

          this.validateContract();
        }

      }
    )

  }

  private validateContract(): void {

    let _dataContract = this._sessionService.getDataContract();
    if (_dataContract) {
      this.isColective = _dataContract.colective;
      this.stateContract = _dataContract.codStateContract;
      this.contratante = this._sessionService.getCurrentUser().actualizacionMenu;
      if (this._sessionService.getCurrentUser().age < 18 && this._sessionService.getSelectDocumentTypeContracted() !== 'N') {
        this.showNews = false;
        this.showEstadoCuenta = false;
        this.showPagoEnLinea = false;
      }
      else {
        this.showNews = true;
        this.showEstadoCuenta = true;
        this.showPagoEnLinea = true;
      }
     // console.log(this.stateContract);
    }

  }

  toggleSidebar() {
    jQuery('.app-sidebar').removeClass('active');
    jQuery('.app-container').removeClass('__sidebar');
  }

  consultAuthorization() {
    this.toggleSidebar();
    this.router.navigate(['/office/authorization/consult']);
  }

  requestAuthorization() {
    this.toggleSidebar();
    this.router.navigate(['/office/authorization/request']);
  }

  medicalAppointments() {
    this.toggleSidebar();
    this.router.navigate(['/office/medical_appointment']);
  }

  laboratoryTests() {
    this.toggleSidebar();
    this.router.navigate(['/office/laboratory_tests']);
  }

  cert_afiliacion() {
    this.toggleSidebar();
    this.router.navigate(['/office/certificate/membership']);
  }

  estado_cuenta() {
    this.toggleSidebar();
    this.router.navigate(['/office/account_status/status']);
  }

  factura_online() {
    this.toggleSidebar();
    this.router.navigate(['/office/account_status/online_invoice']);
  }

  cert_cobertura_exterior() {
    this.toggleSidebar();
    this.router.navigate(['/office/certificate/coverage_abroad']);
  }

  cert_paz_salvo() {
    this.toggleSidebar();
    this.router.navigate(['/office/certificate/peace_save']);
  }

  cert_ingreso_retencion() {
    this.toggleSidebar();
    this.router.navigate(['/office/certificate/income']);
  }

  home_certificados() {
    let _sidevarMobile = this.sidevarMobile();
    if (!_sidevarMobile) {
      this.toggleSidebar();
      this.router.navigate(['/office/certificate/home']);
    }

  }

  home_estado_cuenta() {
    let _sidevarMobile = this.sidevarMobile();
    if (!_sidevarMobile) {
      this.toggleSidebar();
      this.router.navigate(['/office/account_status/status']);
    }
  }

  home_autorizaciones() {
    let _sidevarMobile = this.sidevarMobile();
    if (!_sidevarMobile) {
      this.toggleSidebar();
      this.router.navigate(['/office/authorization/home']);
    }
  }

  home_formatos() {
    let _sidevarMobile = this.sidevarMobile();
    if (!_sidevarMobile) {
      this.toggleSidebar();
      this.router.navigate(['/office/news/home']);
    }
  }

  formatos_novedades() {
    this.toggleSidebar();
    this.router.navigate(['/office/news/format']);
  }

  formatos_reintegros() {
    this.toggleSidebar();
    this.router.navigate(['/office/news/reintegrate']);
  }

  formatos_reembolsos() {
    let _sidevarMobile = this.sidevarMobile();
    if (!_sidevarMobile) {
      this.toggleSidebar();
      this.router.navigate(['/office/refunds/home']);
    }
    //this.toggleSidebar();
    //this.router.navigate(['/office/news/refund']);
    //this.router.navigate(['/office/news/refund-request-stepone']);
  }

  cobertura_en_exterior() {
    this.toggleSidebar();
    this.router.navigate(['/office/news/coverage-abroad']);
  }

  homeOffice() {
    this.router.navigate(['/office/home']);
  }

  medplusWeb() {
    window.open("https://www.medplus.com.co", "_blank");
  }

  directorioWeb() {
    window.open("http://directorio.medplus.com.co/", "_blank");
  }

  sidevarMobile(): boolean {
    return jQuery(".app-sidebar").hasClass("active");
  }

  pago_online() {

    if (this.dataContract.dPayValue > 0) {

      sessionStorage.removeItem('sessionPagos');

      //console.log(this.dataContract);

      this._paymentService.getIva().subscribe(
        res => {

          let _iva = res;

          let _valorIva = (this.dataContract.dPayValue * ((_iva * 100) / 110));

          let _obj = {
            consecutivo: this.dataContract.numContractConsecutive,
            valorPago: this.dataContract.dPayValue,
            valorIva: _valorIva,
            baseIva: this.dataContract.dPayValue - _valorIva,
            email: this._sessionService.getCurrentUser().user,
            identificacion: this._sessionService.getCurrentUser().documentId,
            contrato: this._sessionService.getSelectContract(),
            hash: this.dataContract.fnMd5,
            identificaciond: '',
            nombreUsuario: this.dataContract.name,
            factura: this.dataContract.factura
          }

          sessionStorage.setItem('sessionPagos', JSON.stringify(_obj));
          this.router.navigate(['/office/account_status/payments']);

        },
        err => {
          swal({
            title: 'Pagos en Línea',
            html: '<p style="font-size:14px">Existe inconvenientes con los pagos. Por favor intente más tarde</p>',
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
          console.log(err);
        }
      )
    } else {
      swal({
        title: 'Pagos en Línea',
        html: '<p style="font-size:14px">No Tiene ningún saldo pendiente.</p>',
        type: 'info',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
    }

  }


  servicioAlCliente(){
    this.toggleSidebar();
    this.router.navigate(['/office/service_client']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/layout-sidebar-menu/layout-sidebar-menu.component.ts